import React, { useCallback, useEffect, useRef, useState } from "react";
import { AppDialog } from "@/shared/components/AppDialog";
import {
  registerAppDialogListener,
  type AppDialogRequest,
} from "@/shared/utils/appDialog";

interface AppDialogProviderProps {
  children: React.ReactNode;
}

export const AppDialogProvider: React.FC<AppDialogProviderProps> = ({
  children,
}) => {
  const [request, setRequest] = useState<AppDialogRequest | null>(null);
  const queueRef = useRef<AppDialogRequest[]>([]);

  useEffect(() => {
    return registerAppDialogListener((next) => {
      setRequest((current) => {
        if (current) {
          queueRef.current.push(next);
          return current;
        }
        return next;
      });
    });
  }, []);

  const onDismiss = useCallback(() => {
    const next = queueRef.current.shift() ?? null;
    setRequest(next);
  }, []);

  return (
    <>
      {children}
      <AppDialog request={request} onDismiss={onDismiss} />
    </>
  );
};
